import { z } from 'zod';
import { CompanyDetailTabs } from '../enums';
import { PaymentsTabActiveSegment } from '../../payment/components/tables/types';

// TODO - add to the route
export const companyDetailsQuerySchema = z.object({
    tab: z.nativeEnum(CompanyDetailTabs).default(CompanyDetailTabs.Details),
    activeSegment: z.nativeEnum(PaymentsTabActiveSegment).optional(),
    billId: z.string().uuid().optional(),
});

export type CompanyDetailsQueryValues = z.infer<typeof companyDetailsQuerySchema>;
